// extracted by mini-css-extract-plugin
module.exports = {"bcg":"ErrorBoundary_bcg__3Ga1_","title":"ErrorBoundary_title__1kA8E"};